
import styled, { css } from 'styled-components';

const ButtonsGroup = () => css`
    ${({ theme, isDesktop, christmasTheme }) => (
    theme == 'vivaTheme' &&
    `
        bottom: 5%;
        z-index: 1111;
        display: flex;
        position: ${christmasTheme ? '' : 'absolute'};
        justify-content: ${christmasTheme ? 'center' : ''};
        margin: ${christmasTheme ? '0 auto' : ''};
        width: 25%;
        left:${isDesktop ? '10%' : '5%'};
        height: 25%;

        @media (max-height: 850px) {
          height: 25%;
        }
        `
  ) ||
    theme != 'vivaTheme' &&
    `
    bottom: 5%;
    z-index: 1111;
    display: flex;
    position: absolute;
    width: 100%;
    height: 10%;

    @media (max-height: 850px) {
      height: 15%;
    }
        `

  }
`;


export default styled.div([ButtonsGroup]);